<template>
  <v-row class="mt-4">
    <v-col cols="12" class="pb-0">
      <v-sheet color="blue lighten-5" rounded class="py-2 px-4">
        <span class="text-subtitle-1 font-weight-bold blue--text">{{ titulo }}</span>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ETituloSecaoAEE",
  props: {
    titulo: {
      type: String,
      required: true,
    },
  },
};
</script>
